import { render, staticRenderFns } from "./fancyDialogList.vue?vue&type=template&id=a143deb6&scoped=true"
import script from "./fancyDialogList.vue?vue&type=script&lang=js"
export * from "./fancyDialogList.vue?vue&type=script&lang=js"
import style0 from "./fancyDialogList.vue?vue&type=style&index=0&id=a143deb6&prod&scoped=true&lang=css"
import style1 from "./fancyDialogList.vue?vue&type=style&index=1&id=a143deb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a143deb6",
  null
  
)

export default component.exports